import * as React from "react";
import { AddWidgetModel } from "./AddWidgetModel.js";
import { AddWidgetView } from "./AddWidgetView.jsx";
export { AddWidget, AddWidgetModel, AddWidgetView };
/**
 * Виджет добавления виджетов в `WidgetGrid`.
 * @param {Object} props - Атрибуты элемента.
 * @param {WidgetGridModel} props.widget_grid - Модель сетки виджетов.
 * @param {Locale} props.locale - Локализация названий виджетов.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function AddWidget({ widget_grid, locale, onSubmit }) {
  const [open, setOpen] = React.useState(false);
  const model = new AddWidgetModel({
    widget_grid, locale, open, onClick, onSubmit: onSubmitWrapper
  });
  return <AddWidgetView model={model} />;
  // Обработка событий
  function onClick(event) {
    if (event.preventDefault) event.preventDefault();
    setOpen(!open);
  }
  function onSubmitWrapper(data) {
    setOpen(false);
    for (const field in data) {
      const i = widget_grid.indexOf(field);
      if (i < 0) {
        console.error("AddWidget.onSubmitWrapper.i < 0 for", field);
        continue;
      }
      widget_grid.grid[i].visible = data[field];
    }
    onSubmit(widget_grid);
  }
}